import { CREATE_TRACKED_LINK_CLICK } from '../constants'

import AbstractService from './AbstractService'

export type CreateTrackedLinkClickRequest = {
  linkKey: string
  linkLabel: string
  targetUrl: string
  source?: string
}

class TrackedLinkClickServiceClass extends AbstractService {
  create = (data: CreateTrackedLinkClickRequest) => {
    return this.request(CREATE_TRACKED_LINK_CLICK, 'post', false, data)
  }
}

export const TrackedLinkClickService = new TrackedLinkClickServiceClass()
